import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { Constanciadigital } from 'src/app/models/constanciadigital';
import {ConstanciadigitalService} from 'src/app/services/constanciadigital.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-acreditaciones',
  templateUrl: './acreditaciones.component.html',
  styleUrls: ['./acreditaciones.component.css']
})
export class AcreditacionesComponent implements OnInit {
  muestraDescarga:boolean;
  constancias: Constanciadigital[];
  pdfSrc:string;
  mostrarTabla:boolean;
  constanciaUpdate: Constanciadigital = new Constanciadigital();
  constructor(private constanciaDigitalService:ConstanciadigitalService,
    private activateRouter: ActivatedRoute,private router:Router ) {
      this.muestraDescarga=false;
      this.mostrarTabla=false;
     }

  ngOnInit(): void {
    //primeramente ogtenemos el token
    
    this.activateRouter.params.subscribe(
      params => {
        let id = params['id'];
        if(id){
          this.constanciaDigitalService.getConstancias(id).subscribe(
            constancias => this.constancias = constancias);
            this.mostrarTabla=true;
        }
      }
    )
    
    
  }
  actualizaConstancia(constancia: Constanciadigital):void{
    
    swal.fire({
      title: 'Aviso',
      text: 'Se recomienda, completar el procesos de descarga, ya que la Constancia Seleccionada, ya no aparecera en la lista.',
      icon: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Enterado'
    }).then((result) => {
      if (result.isConfirmed) {
        this.constanciaUpdate=constancia;
          this.constanciaDigitalService.updateConstancia(this.constanciaUpdate).subscribe(
            response =>{
              swal.fire('COSNTANCIA DISPONIBLE', 'DESCARGE LA MISMA, DANDO CLICK EN EL BOTON "DESCARGAR CONSTANCIA"', 'success');
              this.muestraDescarga=true;
              this.constanciaDigitalService.getConstancias(constancia.profecionistaID).subscribe(
                constancias => this.constancias = constancias);
              this.constancias?.filter(cli => cli !== this.constanciaUpdate);
            }
            )
            this.router.navigate(['/acreditaciones', constancia.profecionistaID]);
            //this.pdfSrc ='https://cnsfdesmic3.cnsf.gob.mx/zuulO2/cnsf/constancia/ver/'+ constancia.id; //>>>>DESARROLLOv2
            //this.pdfSrc = 'http://cnsfdesmic3:9009/cnsf/constancia/ver/'+ constancia.id; //>>>>DESARROLLO
            this.pdfSrc = 'https://constanciadigital.cnsf.gob.mx/zuulO2/cnsf/constancia/ver/'+ constancia.id; //>>>>PRODUCCION
            //this.pdfSrc = 'https://constanciadigitaldrp.cnsf.gob.mx/zuulO2/cnsf/constancia/ver/'+ constancia.id; //>>>>DRP
            
          } 
      }
    )
   
    
  }
  refrescaVentana(){
    this.muestraDescarga=false;
  }
  salir():void{
    this.router.navigate(['/login']);
  }
}
